// Shared multi-color SVG icons for Value Added Services
// Used on both Home page preview and the full ValueAdded page

export const ValueAddedIcon = ({ type, size = 48 }) => {
  const s = size;
  const half = s / 2;

  const icons = {
    airport: (
      <svg width={s} height={s} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={`ag_${s}`} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#3B82F6"/><stop offset="1" stopColor="#06B6D4"/>
          </linearGradient>
        </defs>
        <rect width="48" height="48" rx="14" fill={`url(#ag_${s})`}/>
        {/* Plane body */}
        <path d="M32 17c1.1 0 2 .9 2 2s-.9 2-2 2l-4 1-6 8H19l2-8-4 1-1.5 2H14l1-4-1-4h1.5L17 17l4 1 2-8h3l6 8z" fill="white" opacity="0.95"/>
        {/* Ground line */}
        <rect x="12" y="33" width="24" height="2" rx="1" fill="white" opacity="0.45"/>
      </svg>
    ),

    insurance: (
      <svg width={s} height={s} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={`ig_${s}`} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#10B981"/><stop offset="1" stopColor="#34D399"/>
          </linearGradient>
        </defs>
        <rect width="48" height="48" rx="14" fill={`url(#ig_${s})`}/>
        {/* Shield */}
        <path d="M24 10l13 4.3v11.5c0 6-4.7 10.5-13 12.2C15.7 36.3 11 31.8 11 25.8V14.3z" fill="white" opacity="0.18"/>
        <path d="M24 13l10.5 3.5v9.8c0 4.8-4 8.5-10.5 9.9-6.5-1.4-10.5-5.1-10.5-9.9V16.5z" fill="white" opacity="0.22"/>
        {/* Heartbeat */}
        <path d="M14 26h4l2-5 3 9 2.5-7 1.5 3H34" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),

    sim: (
      <svg width={s} height={s} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={`sg_${s}`} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#8B5CF6"/><stop offset="1" stopColor="#A78BFA"/>
          </linearGradient>
        </defs>
        <rect width="48" height="48" rx="14" fill={`url(#sg_${s})`}/>
        {/* Phone outline */}
        <rect x="15" y="9" width="18" height="30" rx="3.5" fill="white" opacity="0.18"/>
        <rect x="16.5" y="12" width="15" height="20" rx="2" fill="white" opacity="0.15"/>
        {/* Signal bars */}
        <rect x="18" y="21" width="3" height="7" rx="1.2" fill="white"/>
        <rect x="22.5" y="18" width="3" height="10" rx="1.2" fill="white"/>
        <rect x="27" y="15" width="3" height="13" rx="1.2" fill="white"/>
        {/* Home dot */}
        <circle cx="24" cy="35" r="1.8" fill="white" opacity="0.55"/>
      </svg>
    ),

    bank: (
      <svg width={s} height={s} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={`bg_${s}`} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F59E0B"/><stop offset="1" stopColor="#FBBF24"/>
          </linearGradient>
        </defs>
        <rect width="48" height="48" rx="14" fill={`url(#bg_${s})`}/>
        {/* Roof triangle */}
        <path d="M13 22l11-9 11 9" fill="white" opacity="0.25"/>
        <path d="M13 22l11-9 11 9" stroke="white" strokeWidth="2" strokeLinejoin="round"/>
        {/* Top line */}
        <line x1="13" y1="22" x2="35" y2="22" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        {/* Pillars */}
        <rect x="15" y="22" width="3.5" height="11" rx="0.8" fill="white" opacity="0.85"/>
        <rect x="22.3" y="22" width="3.5" height="11" rx="0.8" fill="white" opacity="0.85"/>
        <rect x="29.5" y="22" width="3.5" height="11" rx="0.8" fill="white" opacity="0.85"/>
        {/* Base */}
        <rect x="12" y="33" width="24" height="3" rx="1.2" fill="white"/>
        {/* Coin on top */}
        <circle cx="24" cy="15" r="2.5" fill="white" opacity="0.8"/>
        <line x1="24" y1="13.5" x2="24" y2="16.5" stroke="#F59E0B" strokeWidth="1.2"/>
        <line x1="22.5" y1="15" x2="25.5" y2="15" stroke="#F59E0B" strokeWidth="1.2"/>
      </svg>
    ),

    police: (
      <svg width={s} height={s} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={`pg_${s}`} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EF4444"/><stop offset="1" stopColor="#F87171"/>
          </linearGradient>
        </defs>
        <rect width="48" height="48" rx="14" fill={`url(#pg_${s})`}/>
        {/* Badge outer ring */}
        <path d="M24 8l4.5 4 6 .8 1.2 6-4 5 4 5-1.2 6-6 .8-4.5 4-4.5-4-6-.8-1.2-6 4-5-4-5 1.2-6 6-.8z"
          fill="white" opacity="0.2"/>
        {/* Badge inner */}
        <path d="M24 11l3.5 3.2 4.7.6.9 4.7-3.1 3.9 3.1 3.9-.9 4.7-4.7.6-3.5 3.2-3.5-3.2-4.7-.6-.9-4.7 3.1-3.9-3.1-3.9.9-4.7 4.7-.6z"
          fill="white" opacity="0.25"/>
        {/* Star */}
        <path d="M24 17l1.7 3.4H29l-2.8 2.2 1.1 3.4L24 24.2l-3.3 1.8 1.1-3.4L19 20.4h3.3z" fill="white"/>
        {/* Check under */}
        <path d="M19.5 31.5l3 3 6-5.5" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),

    attestation: (
      <svg width={s} height={s} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={`attg_${s}`} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#1A7A8A"/><stop offset="1" stopColor="#22A4B8"/>
          </linearGradient>
          <linearGradient id={`sealg_${s}`} x1="0" y1="0" x2="20" y2="20" gradientUnits="userSpaceOnUse">
            <stop stopColor="#C9A84C"/><stop offset="1" stopColor="#E8C97A"/>
          </linearGradient>
        </defs>
        <rect width="48" height="48" rx="14" fill={`url(#attg_${s})`}/>
        {/* Doc page */}
        <rect x="12" y="9" width="18" height="26" rx="2.5" fill="white" opacity="0.2"/>
        <rect x="13.5" y="11" width="15" height="22" rx="2" fill="white" opacity="0.15"/>
        {/* Doc lines */}
        <rect x="16" y="16" width="10" height="1.8" rx="0.9" fill="white" opacity="0.85"/>
        <rect x="16" y="20" width="8" height="1.8" rx="0.9" fill="white" opacity="0.85"/>
        <rect x="16" y="24" width="9" height="1.8" rx="0.9" fill="white" opacity="0.85"/>
        {/* Gold seal */}
        <circle cx="33" cy="33" r="9" fill={`url(#sealg_${s})`}/>
        <circle cx="33" cy="33" r="7.5" fill="none" stroke="white" strokeWidth="1.2" strokeDasharray="2 1.5"/>
        {/* Seal check */}
        <path d="M30 33l2.5 2.5 4.5-5" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),

    contract: (
      <svg width={s} height={s} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={`cg_${s}`} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#6366F1"/><stop offset="1" stopColor="#818CF8"/>
          </linearGradient>
        </defs>
        <rect width="48" height="48" rx="14" fill={`url(#cg_${s})`}/>
        {/* House outline */}
        <path d="M12 26l12-13 12 13" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        {/* House body */}
        <path d="M16 24v11a1.5 1.5 0 001.5 1.5h5.5v-7h6v7h5.5A1.5 1.5 0 0036 35V24" fill="white" opacity="0.85"/>
        {/* Magnifier */}
        <circle cx="35" cy="35" r="6" fill="white" opacity="0.18"/>
        <circle cx="34" cy="34" r="4" fill="none" stroke="white" strokeWidth="2"/>
        <line x1="37" y1="37" x2="40" y2="40" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        {/* Plus in magnifier */}
        <line x1="34" y1="32" x2="34" y2="36" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="32" y1="34" x2="36" y2="34" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  };

  return icons[type] || null;
};

// Map from title string → icon key
export const getIconKey = (title) => {
  const map = {
    'Airport Pickup':                   'airport',
    'Insurance Activation':             'insurance',
    'SIM Card Activation':              'sim',
    'Bank Account Processing':          'bank',
    'Police Verification':              'police',
    'Document Attestation':             'attestation',
    'Accommodation Contract Clearance': 'contract',
  };
  return map[title] || 'airport';
};

// Accent colors for each icon type
export const getAccentColor = (key) => ({
  airport:     '#3B82F6',
  insurance:   '#10B981',
  sim:         '#8B5CF6',
  bank:        '#F59E0B',
  police:      '#EF4444',
  attestation: '#1A7A8A',
  contract:    '#6366F1',
}[key] || '#1A7A8A');
